import { createContext, useContext } from 'react';

import { DEFAULT_THEME, type THEMES } from './config';

export interface IContext {
    /** Тема */
    theme: typeof THEMES[number];
}

export const Context = createContext<IContext>({ theme: DEFAULT_THEME });

export const useMainBannerContext = () => useContext<IContext>(Context);
